import React, {useEffect} from 'react'
import * as PropTypes from 'prop-types'
import {TransactionRemovalReason} from '@modifi/enums'
import {Col, Row, CustomerDialogButtonRow, Alert, WarningAlert} from '@modifi/ui'
import ms from 'ms'

import {Headline, Description} from './styles'
import {useAbility} from '../../../../constants/permissions'
import {TRANSACTION} from '../../../../constants/section'

const DeleteTransactionDialog = ({
  deleteError,
  isDeleting,
  deleteTransaction,
  closeDialog,
  params,
  cleanUpDelete,
}) => {
  useEffect(() => () => cleanUpDelete(), [cleanUpDelete])
  const ability = useAbility()
  const isAllowed = ability.can('delete', TRANSACTION)
  return (
    <>
      {!isAllowed && (
        <Row mt={30} mb={10}>
          <Col col={10} offset={1}>
            <WarningAlert>
              You are lacking permissions to adjust values in this section
            </WarningAlert>
          </Col>
        </Row>
      )}
      <Row mt={30}>
        <Col col={10} offset={1}>
          <Headline>Are you sure you want to want to remove this transaction?</Headline>
        </Col>
      </Row>
      <Row mt={20} mb={50}>
        <Col col={10} offset={1}>
          <Description>The transaction will be removed from the transaction list.</Description>
        </Col>
      </Row>
      {deleteError && (
        <Row mt={30} mb={10}>
          <Col col={6} offset={3}>
            <Alert type="danger">{deleteError}</Alert>
          </Col>
        </Row>
      )}
      <CustomerDialogButtonRow
        canSubmit={!isDeleting && !deleteError && isAllowed}
        onSubmitClick={() => deleteTransaction(params.id, TransactionRemovalReason.NOT_SPECIFIED)}
        submitText="REMOVE TRANSACTION"
        alert
        hasCancel
        canCancel
        cancelText="CLOSE"
        onCancelClick={closeDialog}
        expectedSubmitDuration={ms('1s')}
      />
    </>
  )
}

DeleteTransactionDialog.propTypes = {
  deleteError: PropTypes.string,
  isDeleting: PropTypes.bool.isRequired,
  params: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,

  closeDialog: PropTypes.func.isRequired,
  deleteTransaction: PropTypes.func.isRequired,
  cleanUpDelete: PropTypes.func.isRequired,
}

DeleteTransactionDialog.defaultProps = {
  deleteError: null,
}

export default DeleteTransactionDialog
